var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "home"
  }, [_c('Header'), _c('div', {
    staticClass: "usercont content"
  }, [_c('NavMenu'), _c('div', {
    staticClass: "menucont"
  }, [_c('ul', [_c('li', {
    class: {
      active: _vm.form.invoiceType === 1 || _vm.form.invoiceType === 2
    },
    on: {
      "click": function click($event) {
        return _vm.selectType(2);
      }
    }
  }, [_vm._v(" 增值税电子普票 ")]), _c('li', {
    class: {
      active: _vm.form.invoiceType === 3
    },
    on: {
      "click": function click($event) {
        return _vm.selectType(3);
      }
    }
  }, [_vm._v("增值税电子专票")])]), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "130px",
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "发票抬头：",
      "prop": "pass"
    }
  }, [_c('div', {
    staticClass: "rise"
  }, [_vm.form.invoiceType !== 3 ? _c('span', {
    class: {
      active: _vm.form.invoiceType === 1
    },
    on: {
      "click": function click($event) {
        return _vm.selectType(1, 'type');
      }
    }
  }, [_vm._v(" 个人 "), _vm.form.invoiceType === 1 ? _c('i', {
    staticClass: "iconfont iconbianzu1"
  }) : _vm._e()]) : _vm._e(), _c('span', {
    class: {
      active: _vm.form.invoiceType === 2 || _vm.form.invoiceType === 3
    },
    on: {
      "click": function click($event) {
        return _vm.selectType(2, 'type');
      }
    }
  }, [_vm._v(" 单位 "), _vm.form.invoiceType === 2 || _vm.form.invoiceType === 3 ? _c('i', {
    staticClass: "iconfont iconbianzu1"
  }) : _vm._e()])])]), _vm.form.invoiceType === 1 ? _c('el-form-item', {
    attrs: {
      "label": "全名：",
      "prop": "invoiceName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入全名"
    },
    model: {
      value: _vm.form.invoiceName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "invoiceName", $$v);
      },
      expression: "form.invoiceName"
    }
  })], 1) : _c('el-form-item', {
    attrs: {
      "label": "公司名称：",
      "prop": "invoiceName"
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.searchCompany,
      "trigger-on-focus": false,
      "placeholder": "请输入公司名称"
    },
    on: {
      "select": _vm.searchNo
    },
    model: {
      value: _vm.form.invoiceName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "invoiceName", $$v);
      },
      expression: "form.invoiceName"
    }
  })], 1), _vm.form.invoiceType !== 1 ? _c('el-form-item', {
    attrs: {
      "label": "纳税人识别号：",
      "prop": "invoiceNo"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "18",
      "placeholder": "请填写纳税人识别号"
    },
    model: {
      value: _vm.form.invoiceNo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "invoiceNo", $$v);
      },
      expression: "form.invoiceNo"
    }
  })], 1) : _vm._e(), _vm.form.invoiceType === 3 ? _c('el-form-item', {
    attrs: {
      "label": "注册地址：",
      "prop": "companyAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "100",
      "placeholder": "请填写注册地址"
    },
    model: {
      value: _vm.form.companyAddress,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "companyAddress", $$v);
      },
      expression: "form.companyAddress"
    }
  })], 1) : _vm._e(), _vm.form.invoiceType !== 2 ? _c('el-form-item', {
    attrs: {
      "label": "电话：",
      "prop": "telephone"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "20",
      "placeholder": "请填写电话"
    },
    model: {
      value: _vm.form.telephone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "telephone", $$v);
      },
      expression: "form.telephone"
    }
  })], 1) : _vm._e(), _vm.form.invoiceType === 3 ? _c('el-form-item', {
    attrs: {
      "label": "开户行：",
      "prop": "bank"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "30",
      "placeholder": "请填写开户行"
    },
    model: {
      value: _vm.form.bank,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bank", $$v);
      },
      expression: "form.bank"
    }
  })], 1) : _vm._e(), _vm.form.invoiceType === 3 ? _c('el-form-item', {
    attrs: {
      "label": "银行账号：",
      "prop": "bankNo"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写银行账号"
    },
    model: {
      value: _vm.form.bankNo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bankNo", $$v);
      },
      expression: "form.bankNo"
    }
  })], 1) : _vm._e(), _c('el-form-item', {
    attrs: {
      "label": "接收邮箱：",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写电子发票接收邮箱"
    },
    model: {
      value: _vm.form.email,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1), _c('el-form-item', [_c('div', {
    staticClass: "invoicefooter"
  }, [_c('span', {
    on: {
      "click": _vm.saveInvoice
    }
  }, [_vm._v("确定")])])])], 1)], 1)], 1), _c('Footer')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };